type Props = {
  size?: number
}

const Lines360 = ({ size }: Props) => {
  return (
    <svg width={ size || 496 } height={ size || 496 } viewBox="0 0 496 496" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="248" cy="248" r="247" stroke="#ED8B00" strokeWidth="2"/>
      <path d="M495 259.085C495 290.523 467.738 319.294 422.939 340.264C378.22 361.196 316.37 374.17 248 374.17C179.63 374.17 117.78 361.196 73.0615 340.264C28.2623 319.294 1 290.523 1 259.085C1 227.647 28.2623 198.876 73.0615 177.906C117.78 156.974 179.63 144 248 144C316.37 144 378.22 156.974 422.939 177.906C467.738 198.876 495 227.647 495 259.085Z" stroke="#ED8B00" strokeWidth="2"/>
      <path d="M248.085 495C216.647 495 187.876 467.738 166.906 422.939C145.974 378.22 133 316.37 133 248C133 179.629 145.974 117.78 166.906 73.0614C187.876 28.2623 216.647 0.999994 248.085 0.999995C279.523 0.999996 308.294 28.2623 329.264 73.0615C350.196 117.78 363.17 179.63 363.17 248C363.17 316.37 350.196 378.22 329.264 422.939C308.294 467.738 279.523 495 248.085 495Z" stroke="#ED8B00" strokeWidth="2"/>
    </svg>
  );
};

export default Lines360;